import { useUdenlandskeAdvokatsamfund } from "../../hooks/useQueries";
import DefaultDropdownItem from "../dropdown/DefaultDropdownItem";
import SuperDropdown from "../dropdown/SuperDropdown";
import CloseIcon from "../icons/CloseIcon";

interface IUdenlandskAdvokatsamfundFormControlProps {
  value: IUdenlandskAdvokatsamfund | undefined;
  onChange: (us: IUdenlandskAdvokatsamfund | undefined) => void;
  classNameContainer?: string;
}
export default function UdenlandskAdvokatsamfundFormControl(
  props: IUdenlandskAdvokatsamfundFormControlProps,
) {
  const {
    // getUdenlandskAdvokatsamfundError,
    getUdenlandskAdvokatsamfundIsLoading,
    udenlandskeAdvokatsamfund,
  } = useUdenlandskeAdvokatsamfund();
  const { onChange, value, classNameContainer } = props;

  if (!udenlandskeAdvokatsamfund) {
    if (getUdenlandskAdvokatsamfundIsLoading) {
      return (
        <div className="form-control">Henter udenlandske advokatsamfund</div>
      );
    } else {
      return (
        <div className="form-control d-flex align-items-center justify-content-between">
          Kunne ikke hente udenlandske advokatsamfund
        </div>
      );
    }
  }
  if (value) {
    return (
      <button
        className="form-control d-flex align-items-center justify-content-between"
        onClick={() => onChange(undefined)}
      >
        <span>
          {udenlandskeAdvokatsamfund.find((u) => {
            return u.id.toLowerCase() === value.id.toLowerCase();
          })?.navn ?? ""}
        </span>
        <CloseIcon />
      </button>
    );
  }

  return (
    <SuperDropdown
      classNameContainer={classNameContainer}
      items={udenlandskeAdvokatsamfund}
      placeholder="Vælg"
      itemsIdKey={"id"}
      itemToString={(item) => item?.navn ?? ""}
      itemToElement={(item) => <DefaultDropdownItem label={item.navn} />}
      filterKeys={["navn", "beskrivelse"]}
      onSelectedItemEvent={(item) => {
        if (item.selectedItem) {
          onChange(item.selectedItem);
        }
      }}
    />
  );
}
